import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import Bodyweight from "./Bodyweight";
import _ from "lodash";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const BodyWeightController = async (app) => {
  app.get("/bodyweight", async ({ res, req, locals, load }) => {
    const { query } = req;

    const { bodycomp, showBack } = query;

    let comesFromBodyComp = false;

    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    // Required conditional because this could be undefined when refreshing
    if (Boolean(bodycomp) && req?.original?.headers?.referer) {
      comesFromBodyComp =
        req.original.headers.referer.includes("body-composition") ||
        req.original.headers.referer.includes("check-in-summary");
    }
    if (showBack) comesFromBodyComp = true;
    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <Bodyweight comesFromBodyComp={comesFromBodyComp} />;
  });
};

export default BodyWeightController;
